<template>
  <div>
<!-- todo(TECH-325): rewrite as AmountInput-->
    <v-label>{{label}}</v-label>
    <div>
      <v-btn flat
             :disabled="!decreaseAllowed"
             color="primary"
             icon
             @click="handleDecreaseClick">
        <v-icon small>remove_circle</v-icon>
      </v-btn>
      <b>{{value}}</b>
      <v-btn flat
             :disabled="!increaseAllowed"
             color="primary"
             icon
             @click="handleIncreaseClick">
        <v-icon small>add_circle</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
  // todo(egor): integrate with vue forms
    export default {
        name: 'number-input',
        props: {
            value: {
                type: Number,
            },
            minValue: {
                type: Number,
                required: true
            },
            maxValue: {
                type: Number,
                required: true
            },
            label: String
        },
        data() {
            return {
            }
        },
        computed: {
            decreaseAllowed() {
                return this.value - 1 >= this.minValue
            },
            increaseAllowed() {
                return this.value + 1 <= this.maxValue
            }
        },
        methods: {
            handleDecreaseClick() {
                this.$emit('input', this.value - 1)
            },
            handleIncreaseClick() {
                this.$emit('input', this.value + 1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/NumberInput.vue